import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import FormModifier from './alterStructure';
import { Form } from '../form.component';
import { FormCallbacks } from '../formUtils';
import { Status, subscribeTracker } from '../tracker';

export class SubscribeForm extends PureComponent {
  static propTypes = {
    hostWindow: PropTypes.object,
    host: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.initFormCallbacks();
  }

  onSubmit = () => {
    subscribeTracker.updateStatus(Status.SUBMITTED);
  };

  initFormCallbacks() {
    const formModifier = new FormModifier(this.props.host);
    const callbacks = new FormCallbacks(this.props.hostWindow);
    callbacks.add('preSegue', this.onSubmit);
    callbacks.add('postRender', formModifier.populate);
    callbacks.add('onSubmit', this.onSubmit);
  }

  render = () => <Form {...this.props} />;
}
